import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ImageA from 'components/Image/ImageA';
import Button from 'components/Button';
import classes from './CardBlogB.module.scss';

const CardBlogB = (props) => {
  const {
    title,
    description,
    additionalDescription,
    image,
    imageAltText,
    url,
    target,
    creator,
    publishedDate,
    imageHeight,
    imageWidth,
  } = props;

  let Component = 'div';
  let componentProps = {};
  let ButtonToBeRendered = null;

  // if there is a url then make the container a link
  if (url) {
    Component = 'a';
    componentProps = { href: url, target, className: classes.link };
    ButtonToBeRendered = additionalDescription && (
      <Button
        subType='ButtonA'
        title={additionalDescription}
        rightIcon='far fa-chevron-right'
        href={url}
        target={target}
        className={classes.button}
      />
    );
  }

  const publishedDateFormat = publishedDate ? new Date(publishedDate) : null;

  return (
    <div className={classes.container}>
      <div className={classes.textContentWrapper}>
        {title &&
        <Component {...componentProps}>
          <h2 className={classes.title} dangerouslySetInnerHTML={{ __html: title }} />
        </Component>}
        {description &&
        <div className={classes.descriptionContainer}>
          <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />
          <div className={classes.descriptionOverflow} />
        </div>}
        {additionalDescription && (
          ButtonToBeRendered || (
          <Component {...componentProps}>
            <div className={classes.additionalDescription}>{additionalDescription}&nbsp;</div>
          </Component>)
        )}
        {(creator || publishedDateFormat) &&
        <div className={classes.publishInfo}>
          <em>
            {creator && `Posted by ${creator} - `}
            {publishedDateFormat && `${moment(publishedDateFormat).format('MMMM D, YYYY')}`}
          </em>
        </div>}
      </div>
      <div className={classes.imageContentWrapper}>
        {image &&
          <Component {...componentProps}>
            <ImageA
              className={classes.image}
              altText={imageAltText}
              url={image}
              width={imageWidth}
              height={imageHeight}
            />
          </Component>}
      </div>
    </div>
  );
};

CardBlogB.propTypes = {
  /**
   * Title of the Blog
  */
  title: PropTypes.string,
  /**
   * Content of the Blog
  */
  description: PropTypes.string,
  /**
   * Button text
  */
  additionalDescription: PropTypes.string,
  /**
   * Url of the image
  */
  image: PropTypes.string,
  /**
   * Alt text for image
  */
  imageAltText: PropTypes.string,
  /**
   * Link url for image
  */
  url: PropTypes.string,
  /**
   * Target for where to open link
  */
  target: PropTypes.string,
  /**
   * Author of the blog
  */
  creator: PropTypes.string,
  /**
   * Date when the blog was published
  */
  publishedDate: PropTypes.string,
  /**
   * Image height
  */
  imageHeight: PropTypes.number,
  /**
   * Image width
  */
  imageWidth: PropTypes.number,
};

export default CardBlogB;
